import axios from 'axios';

const instanceApi = axios.create({
  baseURL: `/api`
});

export default instanceApi;
